import React from "react";
import { PAGES } from "../constants/localization";

/** Essentially the 404 page */
export const NoMatch = () => {
  return <h1>{PAGES.NOT_FOUND.PAGE_NOT_FOUND}</h1>;
};

export default NoMatch;
